/**
 * This file was automatically generated by @cosmwasm/ts-codegen@1.12.1.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run the @cosmwasm/ts-codegen generate command to regenerate this file.
 */

import * as _0 from "./Escrow.types";
import * as _1 from "./Escrow.client";
import * as _2 from "./Escrow.react-query";
export namespace contracts {
  export const Escrow = {
    ..._0,
    ..._1,
    ..._2,
  };
}
